import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdownContentListItemLabel = function (props) {
    var label = props.label, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-item-label-v2", { ref: ref, label: label }, children));
};
export default VeltCommentsSidebarV2FilterDropdownContentListItemLabel;
